export const REPEAT = {
  off: "OFF",
  once: "ONCE",
  list: "LIST",
};
export const SONG = {
  next: 1,
  prev: -1,
};
